import { render, staticRenderFns } from "./WorkflowRelease.vue?vue&type=template&id=224bac1f&scoped=true"
import script from "./WorkflowRelease.vue?vue&type=script&lang=js"
export * from "./WorkflowRelease.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRelease.vue?vue&type=style&index=0&id=224bac1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224bac1f",
  null
  
)

export default component.exports